function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 15.8811C2.46443 16.4143 9.4457 20.4386 14.41 17.337C19.3742 14.2353 19.1003 8.89165 19.1003 6.443C19.55 5.5009 20.5 5.02195 20.5 2.4719C19.5669 3.3339 18.6394 3.6272 17.7175 3.3518C16.8144 1.97478 15.5718 1.36573 13.9897 1.52467C11.6167 1.76307 10.7485 4.09125 11.004 7.10335C7.34495 8.9537 4.47575 5.762 2.99709 3.3518C2.50304 5.24995 2.02665 7.5288 2.99709 10.0497C3.64405 11.7303 5.19925 13.1512 7.6627 14.3123C5.16615 15.6654 3.11191 16.1883 1.5 15.8811Z",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.5233ddef.svg";
export { ForwardRef as ReactComponent };